export const DESKTOP = 1024;
export const MOBILE = 0;
export const TABLET = 768;



/** WEBPACK FOOTER **
 ** ./src/show-page/constants/responsive-state.js
 **/